import type { ReactNode } from "react";
import { Can } from "@/shared/lib/casl";

export const SectionSecondRowSelectionWithCan = ({
  children,
}: {
  children: ReactNode;
}) => (
  <Can I="edit" a="section_2">
    {children}
  </Can>
);

export const sectionSecondSelectionColumnTitle = (originalNode: ReactNode) => (
  <SectionSecondRowSelectionWithCan>{originalNode}</SectionSecondRowSelectionWithCan>
);

export const sectionSecondSelectionRenderCell = (
  _checked: boolean,
  _record: unknown,
  _index: number,
  originNode: ReactNode,
) => <SectionSecondRowSelectionWithCan>{originNode}</SectionSecondRowSelectionWithCan>;
